/* eslint-disable eqeqeq */
import React, { useCallback, useEffect, useState } from "react";
import {
  API,
  cddFilterOPtions,
  defaultLimitPagination,
  fileUpload,
  get,
  riskProfile,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../../config";
import { useLocation, useNavigate } from "react-router-dom";
import {
  formatMobile,
  formatName,
  formatPhone,
  getModuleNamingBySlug,
} from "../../../lib/Misc";
import BootstrapTable from "react-bootstrap-table-next";
import Pagination from "../../../components/Pagination";
import { debounce } from "lodash";
import MainBody from "../../../components/MainBody/MainBody";
import sortCaret from "../../../components/SortCaret";
import { useTrust } from "../../../lib/context/TrustContext";
// import { Button } from "../../../components/ui/button";
import {
  Calendar,
  CalendarCheck,
  CalendarClockIcon,
  CheckCircle2,
  Clock,
  Clock3,
  Landmark,
  LucideMessageSquareShare,
  RefreshCcw,
  SearchCheck,
} from "lucide-react";
import { useOrganization } from "../../../lib/context/OrganisationContext";
import ExpandCDD from "./ExpandCDD";
import { CaretDownIcon, CaretRightIcon } from "@radix-ui/react-icons";
import CustomTooltip from "../../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { ResponsiveDrawerForm } from "../../../components/ResponsiveDrawerForm";
import VerifyModal from "./VerifyModal";
import RiskChange from "./RiskChange";
import EscalatedModal from "./EscalatedModal";
import UnauthorisedAccess from "../../../UnauthorisedAccess";
import { Button } from "../../../components/ui/button";
import { useUser } from "../../../lib/context/UserContext";
import { AMLCTFModuleConditonIndustry } from "../../../lib/PermissionConditions";
import AddEditVendor from "../../Vendors/AddEditVendor";
import AddEditContact from "../../Contacts/AddEditContact";
import CDDVerifyModal from "../../../components/Assessment_KYC/CDDVerifyModal";
import CDDVerifyCheck from "../../../components/Assessment_KYC/CDDVerifyCheck";
import KYBReportDownload from "../../../components/Assessment_KYC/KYBReportDownload";
import CDDStatus from "../../../components/Assessment_KYC/CDDStatus";
import AdverseMedia from "../../../components/Assessment_KYC/AdverseMedia";
import { AnimatedTooltip } from "../../../components/AnimatedTooltip";
import moment from "moment";
import SearchSelect from "../../../components/SearchSelect";
import CustomLabelText from "../../../components/CustomLabelText";
import { Label } from "../../../components/ui/label";
import Confirmation from "../../../components/Confirmation";
import NameUpdate from "./NameUpdate";
import KYCIncomplete from "./KYCIncomplete";

// * Start: Vendor Listing Page
const EnhancedCDD = ({ sectionType, readAccess, writeAccess }) => {
  // * Start: Url Management State
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const search = query.get("search");
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const defaultFilter = query.get("filter");
  const { organizationData } = useOrganization();
  const { userData } = useUser();

  let amlCTFEnable =
    (userData?.email === "dchoradiya@gmail.com" ||
      organizationData?.organizationData?.is_aml_ctf_subscribed) &&
    AMLCTFModuleConditonIndustry(organizationData)
      ? true
      : false;

  // * End: Url Management State

  // * Start: List Management State

  const { trustId } = useTrust();
  const [enhancedCDDsList, setEnhancedCDDsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();
  const [searchParam, setSearchParam] = useState(search || "");
  const [searchParamData, setSearchParamData] = useState(search || "");
  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  const [confirmEscalated, setConfirmEscalated] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [cddId, setCddId] = useState("");
  const [cddItem, setCddItem] = useState("");

  // const [mobile, setMobile] = useState();
  // const [consent, setConsent] = useState();

  const [showVisual, setShowVisual] = useState(false);
  const [showRisk, setShowRisk] = useState(false);

  const [edit, setEdit] = useState(false);
  const [onlyKyc, setOnlyKyc] = useState(false);

  const [contactId, setContactId] = useState(null);
  const [showAddEditContact, setShowAddEditContact] = useState(false);

  const [vendorId, setVendorId] = useState(null);
  const [showAddEditVendor, setShowAddEditVendor] = React.useState(false);

  const [filterValue, setFilterValue] = useState(defaultFilter || null);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [showAllStatus, setShowAllStatus] = useState(false);

  const toggleShowAllStatus = () => {
    setShowAllStatus(!showAllStatus);
  };

  const handleAllStatus = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      for (let i = 0; i < selectedRowIds?.length; i++) {
        formData.append(`kyc_ids[${i}]`, selectedRowIds[i]);
      }
      await fileUpload(`${API.CDD_ALL_KYC_STATUS}`, formData);
      setLoading(false);
      setSelectedRowIds([]);
      fetchEnhancedCDDs(limit, page);
      toggleShowAllStatus();
    } catch (e) {
      setLoading(false);
      return null;
    }
  };

  const toggleShowAddEditContact = () => {
    if (showAddEditContact) {
      setEdit(false);
      setOnlyKyc(false);
      setContactId(null);
    }
    setShowAddEditContact(!showAddEditContact);
  };

  const toggleShowAddEditVendor = () => {
    if (showAddEditVendor) {
      setEdit(false);
      setOnlyKyc(false);
      setVendorId(null);
    }
    setShowAddEditVendor(!showAddEditVendor);
  };

  // * End: List Management State

  /**
   * * Start: Fetch Vendor List Form The API
   * @param {Number} passLimit (Number of Limit for each page)
   * @param {Number} passPage (Number of Page for records)
   * @returns {Array} Vendor List
   **/

  const fetchEnhancedCDDs = useCallback(
    async (passLimit, passPage) => {
      try {
        setLoading(true);
        const { data } = await get(
          `${API.GET_CDDS}?limit=${
            passLimit ? passLimit : limit ? limit : defaultLimitPagination
          }&page=${passPage ? passPage : page ? page : 1}&search=${
            searchParam ? searchParam : ""
          }&sort_column=${sortField ? sortField : ""}&sort_order=${
            sortOrder ? sortOrder : ""
          }&trust_id=${trustId}&cdd=1&cdd_customer_type=${sectionType}&organization_id=${
            organizationData?.organizationId
              ? organizationData?.organizationId
              : ""
          }&filter=${filterValue ? filterValue : ""}`,
        );
        setLoading(false);
        setLimit(data?.data?.per_page);
        setPage(data?.data?.current_page);
        setTotal(data?.data?.total);
        setFrom(data?.data?.from);
        setTo(data?.data?.to);
        const enhancedCDDsList = data.data.data;
        setEnhancedCDDsList(enhancedCDDsList);
        return data.data;
      } catch (error) {
        setEnhancedCDDsList([]);
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      searchParam,
      sortOrder,
      sortField,
      trustId,
      sectionType,
      organizationData,
      filterValue,
    ],
  );

  //* End: Fetch Vendor List Form The API

  const toggleConfirmEscalated = (id, data) => {
    if (confirmEscalated) {
      setCddId();
      setCddItem();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setConfirmEscalated(!confirmEscalated);
  };

  const toggleVisual = (id, data) => {
    if (showVisual) {
      setCddId();
      setCddItem();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setShowVisual(!showVisual);
  };

  const toggleRisk = (id, data) => {
    if (showRisk) {
      setCddId();
      setCddItem();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setShowRisk(!showRisk);
  };

  // const handleVerifyID = async () => {
  //   try {
  //     setLoading(true);
  //     await get(
  //       `${API.GET_CDD_VERFIY}/${cddId}?cdd=1&cdd_customer_type=${sectionType}&mobile=${mobile}`,
  //     );
  //     setLoading(false);
  //     fetchEnhancedCDDs();
  //   } catch (error) {
  //     setLoading(false);
  //     fetchEnhancedCDDs();
  //   }
  // };

  /**
   * * Start: Vendor Table List Record Generation
   * @param {Number} quantity (Number of EnhancedCDDs)
   * @returns {Array} Vendor List
   **/

  const enhancedCDDsGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      let smsDate = enhancedCDDsList[i]?.verifications[0]?.sms_sent_date
        ? enhancedCDDsList[i]?.verifications[0]?.sms_sent_date
        : "";

      let contactType = enhancedCDDsList[i]?.joint_account_id
        ? 4
        : enhancedCDDsList[i]?.beneficiary_id
          ? 3
          : enhancedCDDsList[i]?.contact_id
            ? 2
            : enhancedCDDsList[i]?.vendor_id
              ? 1
              : "";

      let contact = enhancedCDDsList[i]?.joint_account_id
        ? enhancedCDDsList[i]?.joint_account
        : enhancedCDDsList[i]?.beneficiary_id
          ? enhancedCDDsList[i]?.beneficiary
          : enhancedCDDsList[i]?.vendor_id
            ? enhancedCDDsList[i]?.vendor
            : enhancedCDDsList[i]?.contact_id
              ? enhancedCDDsList[i]?.contact
              : "";

      contact.mobile = contact?.mobile
        ? contact?.mobile[0] === "+"
          ? contact?.mobile
          : `+${contact?.mobile}`
        : "";
      items.push({
        key: enhancedCDDsList[i]?.id,
        id: enhancedCDDsList[i]?.id ? enhancedCDDsList[i]?.id : "",
        contact_type: enhancedCDDsList[i]?.joint_account_id
          ? "Joint Account"
          : enhancedCDDsList[i]?.beneficiary_id
            ? "Beneficiary"
            : enhancedCDDsList[i]?.vendor_id
              ? getModuleNamingBySlug(
                  organizationData?.organizationData,
                  "vendors",
                  "Vendor",
                )
              : enhancedCDDsList[i]?.contact_id
                ? getModuleNamingBySlug(
                    organizationData?.organizationData,
                    "contacts",
                    "Customer",
                  )
                : "",
        code: contact?.code ? contact?.code : "",
        name: (
          <div className="flex items-center justify-between gap-3">
            <div>
              {formatName(contact?.first_name, contact?.last_name) +
                (contact?.business_name ? ` (${contact?.business_name})` : "")}
            </div>
            <NameUpdate
              contactData={{
                first_name: contact?.first_name ? contact?.first_name : "",
                last_name: contact?.last_name ? contact?.last_name : "",
                dob: contact?.dob ? contact?.dob : "",
                street: contact?.street ? contact?.street : "",
                suburb_id: contact?.suburb_id ? contact?.suburb_id : "",
                suburb: contact?.suburb?.name ? contact?.suburb?.name : "",
                state_id: contact?.state_id ? contact?.state_id : "",
                state: contact?.state?.short_name
                  ? contact?.state?.short_name
                  : "",
                postal_code: contact?.postal_code ? contact?.postal_code : "",
              }}
              kycData={{
                first_name: enhancedCDDsList[i]?.match_details?.name?.first_name
                  ? enhancedCDDsList[i]?.match_details?.name?.first_name
                  : "",
                last_name: enhancedCDDsList[i]?.match_details?.name?.last_name
                  ? enhancedCDDsList[i]?.match_details?.name?.last_name
                  : "",
                dob: enhancedCDDsList[i]?.match_details?.date_of_birth
                  ? enhancedCDDsList[i]?.match_details?.date_of_birth
                  : "",
                street: enhancedCDDsList[i]?.match_details?.address?.street
                  ? enhancedCDDsList[i]?.match_details?.address?.street
                  : "",
                suburb_id: enhancedCDDsList[i]?.match_details?.address
                  ?.suburb_id
                  ? enhancedCDDsList[i]?.match_details?.address?.suburb_id
                  : "",
                suburb: enhancedCDDsList[i]?.match_details?.address?.suburb
                  ? enhancedCDDsList[i]?.match_details?.address?.suburb
                  : "",
                state_id: enhancedCDDsList[i]?.match_details?.address?.state_id
                  ? enhancedCDDsList[i]?.match_details?.address?.state_id
                  : "",
                state: enhancedCDDsList[i]?.match_details?.address?.state
                  ? enhancedCDDsList[i]?.match_details?.address?.state
                  : "",
                postal_code: enhancedCDDsList[i]?.match_details?.address
                  ?.post_code
                  ? enhancedCDDsList[i]?.match_details?.address?.post_code
                  : "",
                match_details: enhancedCDDsList[i]?.match_details
                  ? enhancedCDDsList[i]?.match_details
                  : "",
              }}
              id={enhancedCDDsList[i]?.id ? enhancedCDDsList[i]?.id : ""}
              fetchData={() => fetchEnhancedCDDs(limit, page)}
              matchDetailsUpdated={enhancedCDDsList[i]?.match_details_updated}
            />
          </div>
        ),
        email: contact?.email,
        phone: contact?.phone ? formatPhone(contact?.phone) : "-",
        mobile: contact?.mobile ? formatMobile(contact?.mobile) : "-",
        contact: contact,
        contactType: contactType,
        risk: (
          <div className="flex items-center gap-2">
            {enhancedCDDsList[i]?.risk
              ? riskProfile?.find(
                  (item) => item.value == enhancedCDDsList[i]?.risk,
                )?.label
              : ""}{" "}
            <CustomTooltip message={"Edit"}>
              <span>
                <FontAwesomeIcon
                  icon={faEdit}
                  size="1x"
                  onClick={() => {
                    toggleRisk(enhancedCDDsList[i]?.id, enhancedCDDsList[i]);
                  }}
                />
              </span>
            </CustomTooltip>
          </div>
        ),
        source: enhancedCDDsList[i]?.source ? (
          enhancedCDDsList[i]?.source?.includes("(SMS)") ? (
            <div className="flex items-center gap-2">
              {enhancedCDDsList[i]?.source}{" "}
              {smsDate && (
                <AnimatedTooltip
                  title={
                    <div className="flex items-center gap-4 text-sm">
                      <span>SMS Sent Date:</span>
                      <span className="flex items-center gap-1.5">
                        <Calendar className="h-4 w-4" />
                        {moment(smsDate, "DD-MM-YYYY HH:mm:ss").format(
                          "DD MMM YYYY",
                        )}
                      </span>

                      <span className="flex items-center gap-1.5">
                        <Clock3 className="h-4 w-4" />
                        {moment(smsDate, "DD-MM-YYYY HH:mm:ss").format(
                          "hh:mm:ss A",
                        )}
                      </span>
                    </div>
                  }
                >
                  <CalendarClockIcon className="h-4 w-4 text-webPrimary" />
                </AnimatedTooltip>
              )}
            </div>
          ) : (
            enhancedCDDsList[i]?.source
          )
        ) : (
          ""
        ),
        verifications: enhancedCDDsList[i]?.verifications
          ? enhancedCDDsList[i]?.verifications
          : "",
        bureau: (
          <CDDStatus
            cdd="enhanced"
            contactType={
              enhancedCDDsList[i]?.joint_account_id
                ? "joint account"
                : enhancedCDDsList[i]?.beneficiary_id
                  ? "beneficiary"
                  : enhancedCDDsList[i]?.vendor_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "vendor",
                      )
                    : enhancedCDDsList[i]?.contact_id
                      ? getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "contacts",
                          "customer",
                        )
                      : ""
            }
            data={enhancedCDDsList[i]}
            id={enhancedCDDsList[i]?.id}
            type={"bureau"}
            fetchData={() => fetchEnhancedCDDs(limit, page)}
          />
        ),
        dvs: (
          <CDDStatus
            cdd="enhanced"
            contactType={
              enhancedCDDsList[i]?.joint_account_id
                ? "joint account"
                : enhancedCDDsList[i]?.beneficiary_id
                  ? "beneficiary"
                  : enhancedCDDsList[i]?.vendor_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "vendor",
                      )
                    : enhancedCDDsList[i]?.contact_id
                      ? getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "contacts",
                          "customer",
                        )
                      : ""
            }
            data={enhancedCDDsList[i]}
            id={enhancedCDDsList[i]?.id}
            type={"dvs"}
            fetchData={() => fetchEnhancedCDDs(limit, page)}
          />
        ),
        pep: (
          <CDDStatus
            cdd="enhanced"
            contactType={
              enhancedCDDsList[i]?.joint_account_id
                ? "joint account"
                : enhancedCDDsList[i]?.beneficiary_id
                  ? "beneficiary"
                  : enhancedCDDsList[i]?.vendor_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "vendor",
                      )
                    : enhancedCDDsList[i]?.contact_id
                      ? getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "contacts",
                          "customer",
                        )
                      : ""
            }
            data={enhancedCDDsList[i]}
            id={enhancedCDDsList[i]?.id}
            type={"pep"}
            fetchData={() => fetchEnhancedCDDs(limit, page)}
          />
        ),
        sanction: (
          <CDDStatus
            cdd="enhanced"
            contactType={
              enhancedCDDsList[i]?.joint_account_id
                ? "joint account"
                : enhancedCDDsList[i]?.beneficiary_id
                  ? "beneficiary"
                  : enhancedCDDsList[i]?.vendor_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "vendor",
                      )
                    : enhancedCDDsList[i]?.contact_id
                      ? getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "contacts",
                          "customer",
                        )
                      : ""
            }
            data={enhancedCDDsList[i]}
            id={enhancedCDDsList[i]?.id}
            type={"sanction"}
            fetchData={() => fetchEnhancedCDDs(limit, page)}
          />
        ),
        adverse_media: (
          <AdverseMedia
            adverse_media_result={
              enhancedCDDsList[i]?.summaries[0]?.adverse_media_result
            }
            reference_no={enhancedCDDsList[i]?.summaries[0]?.request_id}
          />
        ),
        risk_assessment_action: (
          <span className="flex items-center gap-2 justify-center">
            {contact?.kyc?.risk_assessment && (
              <>
                <CustomTooltip
                  message={`Assessment Date: ${contact?.kyc?.risk_assessment?.assessment_date}`}
                >
                  <CalendarCheck size={16} />
                </CustomTooltip>
                <span>/</span>
              </>
            )}
            <CustomTooltip message={"Risk Assessment"}>
              <SearchCheck
                size={16}
                onClick={() => {
                  setOnlyKyc(true);
                  setEdit(true);
                  if (enhancedCDDsList[i]?.vendor_id) {
                    toggleShowAddEditVendor();
                    setVendorId(contact?.id);
                  }
                  if (enhancedCDDsList[i]?.contact_id) {
                    toggleShowAddEditContact();
                    setContactId(contact?.id);
                  }
                }}
              />
            </CustomTooltip>
          </span>
        ),
        kyc: enhancedCDDsList[i] ? enhancedCDDsList[i] : "",
        action:
          enhancedCDDsList[i]?.source !== "Multiple" ? (
            <>
              <span className="flex items-center gap-2 justify-center">
                {enhancedCDDsList[i]?.kyb_report_file ? (
                  <KYBReportDownload
                    setLoading={setLoading}
                    kyb_report_file={enhancedCDDsList[i]?.kyb_report_file}
                  />
                ) : (
                  <></>
                )}
                {(enhancedCDDsList[i]?.kyb_report_file &&
                  enhancedCDDsList[i]?.status === 1) ||
                enhancedCDDsList[i]?.status === 1 ? (
                  <Button
                    size={"sm"}
                    className={
                      contact?.type == 2
                        ? "bg-green-800 hover:bg-green-900 text-white h-6 px-2"
                        : "bg-green-500 hover:bg-green-600 text-white h-6 px-2"
                    }
                  >
                    <div className="flex items-center gap-1">
                      {contact?.type == 2 ? (
                        <Landmark size={14} />
                      ) : (
                        <CheckCircle2 size={14} />
                      )}
                      <span>Verified</span>
                    </div>
                  </Button>
                ) : (enhancedCDDsList[i]?.kyb_report_file &&
                    enhancedCDDsList[i]?.status === 2) ||
                  enhancedCDDsList[i]?.status === 2 ||
                  enhancedCDDsList[i]?.status === 3 ? (
                  <>
                    <CDDVerifyModal
                      listData={enhancedCDDsList[i]}
                      setCddItem={setCddItem}
                      setCddId={setCddId}
                      cddItem={cddItem}
                      customerType={contact?.type ? contact?.type : 1}
                      setLoading={setLoading}
                      cddId={cddId}
                      sectionType={sectionType}
                      fecthData={fetchEnhancedCDDs}
                      cdd={0}
                      pending={true}
                      method={enhancedCDDsList[i]?.verifications[0]?.method}
                      defaultMobile={
                        contact?.mobile
                          ? contact?.mobile[0] === "+"
                            ? contact?.mobile
                            : `+${contact?.mobile}`
                          : ""
                      }
                      defaultABN={contact?.abn ? contact?.abn : ""}
                    />
                    <Button
                      size={"sm"}
                      className={
                        enhancedCDDsList[i]?.status === 2
                          ? "bg-yellow-500 hover:bg-yellow-600 text-white h-6 px-2"
                          : "bg-red-500 hover:bg-red-600 text-white h-6 px-2"
                      }
                    >
                      <div className="flex items-center gap-1">
                        <Clock size={14} />
                        <span>
                          {enhancedCDDsList[i]?.status === 2
                            ? "Pending"
                            : "Expired"}
                        </span>
                      </div>
                    </Button>
                    {enhancedCDDsList[i]?.status === 2 ? (
                      <CDDVerifyCheck
                        listData={enhancedCDDsList[i]}
                        setCddId={setCddId}
                        setLoading={setLoading}
                        cddId={cddId}
                        fecthData={fetchEnhancedCDDs}
                      />
                    ) : (
                      <></>
                    )}
                  </>
                ) : enhancedCDDsList[i]?.source !== "Visual" ? (
                  enhancedCDDsList[i]?.source ? (
                    <>
                      <CDDVerifyModal
                        loading={loading}
                        listData={enhancedCDDsList[i]}
                        setCddItem={setCddItem}
                        setCddId={setCddId}
                        cddItem={cddItem}
                        customerType={contact?.type ? contact?.type : 1}
                        setLoading={setLoading}
                        cddId={cddId}
                        sectionType={sectionType}
                        fecthData={fetchEnhancedCDDs}
                        cdd={0}
                        defaultMobile={
                          contact?.mobile
                            ? contact?.mobile[0] === "+"
                              ? contact?.mobile
                              : `+${contact?.mobile}`
                            : ""
                        }
                        defaultABN={contact?.abn ? contact?.abn : ""}
                      />
                      <span>/</span>
                      <CustomTooltip message={"Escalate"}>
                        <span>
                          <LucideMessageSquareShare
                            size={18}
                            onClick={() => {
                              toggleConfirmEscalated(
                                enhancedCDDsList[i]?.id,
                                enhancedCDDsList[i],
                              );
                            }}
                          />
                        </span>
                      </CustomTooltip>
                    </>
                  ) : (
                    <KYCIncomplete
                      contactType={
                        enhancedCDDsList[i]?.joint_account_id
                          ? 4
                          : enhancedCDDsList[i]?.beneficiary_id
                            ? 3
                            : enhancedCDDsList[i]?.contact_id
                              ? 2
                              : enhancedCDDsList[i]?.vendor_id
                                ? 1
                                : ""
                      }
                      amlCTFEnable={amlCTFEnable}
                      contact={contact}
                      type={contact?.type}
                      entityType={contact?.entity_type}
                      fetchData={() => fetchEnhancedCDDs(limit, page)}
                    />
                  )
                ) : (
                  <>
                    <CustomTooltip message={"Escalate"}>
                      <span>
                        <LucideMessageSquareShare
                          size={18}
                          onClick={() => {
                            toggleConfirmEscalated(
                              enhancedCDDsList[i]?.id,
                              enhancedCDDsList[i],
                            );
                          }}
                        />
                      </span>
                    </CustomTooltip>
                    <span>/</span>
                    <CustomTooltip message={"Edit"}>
                      <span>
                        <FontAwesomeIcon
                          icon={faEdit}
                          size="1x"
                          onClick={() => {
                            toggleVisual(
                              enhancedCDDsList[i]?.id,
                              enhancedCDDsList[i],
                            );
                          }}
                        />
                      </span>
                    </CustomTooltip>
                  </>
                )}
              </span>
            </>
          ) : (
            <></>
          ),
      });
    }
    return items;
  };

  const enhancedCDDs = enhancedCDDsGenerator(enhancedCDDsList?.length);

  //* End: Vendor Table List Record Generation

  //* Start: Vendor List Columns

  const columns = [
    {
      dataField: "contact_type",
      text: "Contact type",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "code",
      text: "Code",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    // {
    //   dataField: "phone",
    //   text: "Phone No.",
    //   sort: true,
    //   sortCaret,
    //   headerClasses: THClasses,
    //   classes: TDClasses,
    // },
    {
      dataField: "mobile",
      text: "Mobile No.",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "risk",
      text: "Risk Profile",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "source",
      text: "Source",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "dvs",
      text: "DVS",
      headerAlign: "center",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "bureau",
      text: "Bureau",
      headerAlign: "center",
      headerClasses: THClasses,
      classes: TDClasses,
    },

    {
      dataField: "pep",
      text: "PEP",
      headerAlign: "center",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "sanction",
      text: "Sanctions",
      headerAlign: "center",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    // {
    //   headerClasses: THClasses,
    //   classes: TDClasses,
    //   dataField: "risk_assessment_action",
    //   text: "Onboarding",
    //   align: "center",
    //   headerAlign: "center",
    // },
    {
      dataField: "adverse_media",
      text: "Adverse Media",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "action",
      text: "Action",
      align: "center",
      headerAlign: "center",
      style: { width: "127px" },
    },
  ];

  //* End: Vendor List Columns

  /**
   * * Start: Vendor List Sorting
   * @param {type} (Sort)
   * @param {JSON} (page, sortField, sortOrder) (To get the current value of the table)
   **/
  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC",
      );
    }
  };

  //* End: Vendor List Sorting

  /**
   * * Start: Vendor List Change Limit
   * @param {Event} e (Limit Number)
   **/
  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchEnhancedCDDs(limit, 1);
  };

  //* End: Vendor List Change Limit

  /**
   * * Start: Vendor List Change Page
   * @param {Number} page (Page Number)
   **/
  const handleChangePage = (page) => {
    setPage(page);
    fetchEnhancedCDDs(limit, page);
  };

  //* End: Vendor List Change Page

  //* Start: Vendor List and URL Mangement useEffect

  useEffect(() => {
    fetchEnhancedCDDs();
  }, [fetchEnhancedCDDs]);

  //* End: Vendor List and URL Mangement useEffect

  //* Start: Vendor List Search Record Management

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setSearchParam(nextValue);
      setPage(1);
    }, 300),
    [],
  );

  const handleSearchChange = (event) => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    setPage(1);
    if (nextValue?.length >= 2 || nextValue?.length === 0) {
      debouncedSave(nextValue);
    }
  };

  const handleClearSearch = () => {
    setSearchParamData();
    setSearchParam("");
  };

  //* End: Vendor List Search Record Management

  const expandRow = {
    renderer: (row) => (
      <>
        <ExpandCDD
          expandList={true}
          expandData={row?.verifications}
          kyc={row?.kyc}
          loading={loading}
          setLoading={setLoading}
          fetchCDDs={fetchEnhancedCDDs}
          sectionType={sectionType}
          contact={row?.contact}
          contactType={row?.contactType}
          amlCTFEnable={amlCTFEnable}
        />
      </>
    ),
    onlyOneExpanding: true,
    showExpandColumn: true,
    expandByColumnOnly: true,
    headerClasses: THClasses,
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <CaretDownIcon />;
      }
      return <CaretRightIcon />;
    },
    className: TDClasses,
    expandHeaderColumnRenderer: () => {
      return <></>;
    },
  };

  const arrayRemove = (arr, value) => {
    return arr.filter(function (ele) {
      return ele !== value;
    });
  };

  const selectRow = {
    mode: "checkbox",
    clickToSelect: false,
    selected: selectedRowIds,
    onSelectAll: (row, isSelect) => {
      if (enhancedCDDsList?.length > 0) {
        if (row) {
          const ids =
            isSelect &&
            isSelect?.length > 0 &&
            isSelect?.map((item) => {
              return item?.key;
            });
          setSelectedRowIds(selectedRowIds ? selectedRowIds.concat(ids) : ids);
        } else {
          const removableData =
            isSelect &&
            isSelect?.length > 0 &&
            isSelect.map(function (data) {
              return data?.key;
            });
          setSelectedRowIds(
            selectedRowIds
              ? selectedRowIds.filter((item) => !removableData.includes(item))
              : [],
          );
        }
      }
    },
    onSelect: (row, isSelect) => {
      if (isSelect) {
        setSelectedRowIds((keys) => [...keys, row?.key]);
      } else {
        setSelectedRowIds(arrayRemove(selectedRowIds, row?.key));
      }
    },
  };

  useEffect(() => {
    navigate(
      `?tab=cdd&childTab=${sectionType == 1 ? "ongoing" : "initial"}&subChildTab=enhanced&limit=${
        limit ? limit : defaultLimitPagination
      }&page=${page ? page : 1}&sort_column=${
        sortField ? sortField : ""
      }&sort_order=${sortOrder ? sortOrder : ""}&filter=${filterValue ? filterValue : ""}`,
      {
        replace: true,
      },
    );
  }, [navigate, limit, page, sortField, sortOrder, sectionType, filterValue]);

  return readAccess ? (
    <>
      <MainBody
        searchParamData={searchParamData}
        handleClearSearch={handleClearSearch}
        handleSearchChange={handleSearchChange}
        actionContent={
          <>
            <div className="flex items-center gap-2">
              <div className="grid gap-2">
                <div className="min-w-0 flex items-center gap-2">
                  <Label htmlFor="aml_ctf_contact_id">
                    <CustomLabelText labelText="Filter by:" errorField={""} />
                  </Label>
                  <div className="relative">
                    <SearchSelect
                      frameworks={cddFilterOPtions}
                      optionType={"Filter by"}
                      handleSelect={(e) => {
                        setFilterValue(e);
                      }}
                      clearable={true}
                      initialValue={filterValue ? filterValue : ""}
                      onClear={() => {
                        setFilterValue(null);
                      }}
                    />
                  </div>
                </div>
              </div>
              {filterValue == "pending" && (
                <Button
                  size={"sm"}
                  className="px-2"
                  disabled={selectedRowIds?.length == 0}
                  onClick={() => {
                    toggleShowAllStatus();
                  }}
                >
                  <div className="flex items-center gap-2">
                    <RefreshCcw size={14} />
                    <span>Show All</span>
                  </div>
                </Button>
              )}
            </div>
          </>
        }
        loading={loading}
        innerBody={true}
        parentHeight={true}
        mainClassName="w-[calc(100%-3rem)]"
      >
        {/* Vendor Table and Pagination */}
        <div className="custom-table">
          <div className="table-body-class">
            <BootstrapTable
              keyField="id"
              remote
              data={enhancedCDDs}
              columns={columns}
              onTableChange={handleTableChange}
              expandRow={expandRow}
              selectRow={selectRow}
              rowClasses={(row) => {
                if (row?.kyc?.match_details) {
                  return `${TRClasses} contact-not-match`;
                }
                if (row?.kyc?.match_details_updated) {
                  return `${TRClasses} contact-kyc-update`;
                }
                return TRClasses;
              }}
              noDataIndication="No Data Found"
              classes={TableClasses}
              wrapperClasses={TableWrapClasses}
            />
          </div>

          <Pagination
            total={total}
            limit={parseInt(limit)}
            currentPage={page}
            updateLimit={handleUpdateLimit}
            updatePage={handleChangePage}
            from={from}
            to={to}
          />

          {confirmEscalated && (
            <ResponsiveDrawerForm
              description={""}
              title={`Escalated`}
              handleOpen={() => {}}
              handleClose={() => {
                toggleConfirmEscalated();
              }}
              popupType={"cdds"}
              write={true}
              buttonText={""}
              open={confirmEscalated}
              buttonClassName={""}
              setOpen={setConfirmEscalated}
              className={"sm:max-w-3xl"}
            >
              <EscalatedModal
                data={cddItem}
                toggleConfirmEscalated={toggleConfirmEscalated}
                fetchData={fetchEnhancedCDDs}
              />
            </ResponsiveDrawerForm>
          )}

          {showVisual && (
            <ResponsiveDrawerForm
              description={""}
              title={`Visual Changes`}
              handleOpen={() => {}}
              handleClose={() => {
                toggleVisual();
              }}
              popupType={"cdds"}
              write={true}
              buttonText={""}
              open={showVisual}
              buttonClassName={""}
              setOpen={setShowVisual}
              className={"sm:max-w-3xl"}
            >
              <VerifyModal
                data={cddItem?.verifications[0]}
                toggleVisual={toggleVisual}
                fetchData={fetchEnhancedCDDs}
              />
            </ResponsiveDrawerForm>
          )}

          {showRisk && (
            <ResponsiveDrawerForm
              description={""}
              title={`Risk Change`}
              handleOpen={() => {}}
              handleClose={() => {
                toggleRisk();
              }}
              popupType={"cdds"}
              write={true}
              buttonText={""}
              className={"sm:max-w-3xl"}
              open={showRisk}
              buttonClassName={""}
              setOpen={setShowRisk}
            >
              <RiskChange
                data={cddItem}
                toggleRisk={toggleRisk}
                fetchData={fetchEnhancedCDDs}
              />
            </ResponsiveDrawerForm>
          )}

          {contactId ? (
            <ResponsiveDrawerForm
              description={""}
              title={
                onlyKyc
                  ? `Contact Onboarding Assessment`
                  : edit
                    ? `Edit ${getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "contacts",
                        "Customer",
                      )}`
                    : `Add ${getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "contacts",
                        "Customer",
                      )}`
              }
              handleOpen={() => {}}
              handleClose={() => {
                setEdit(false);
                setOnlyKyc(false);
                setContactId(null);
                setShowAddEditContact(false);
              }}
              buttonText={""}
              className={"overflow-hidden"}
              open={showAddEditContact}
              buttonClassName={""}
              setOpen={setShowAddEditContact}
              write={true}
            >
              <AddEditContact
                edit={edit}
                toggleShowAddEditContact={toggleShowAddEditContact}
                id={contactId}
                setEdit={setEdit}
                onlyKyc={onlyKyc}
                trustId={trustId}
                fetchContactData={() => fetchEnhancedCDDs(limit, page)}
                org={true}
                amlCTFEnable={amlCTFEnable}
              />
            </ResponsiveDrawerForm>
          ) : vendorId ? (
            <>
              <ResponsiveDrawerForm
                description={""}
                title={
                  onlyKyc
                    ? `Vendor Onboarding Assessment`
                    : edit
                      ? `Edit ${getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "vendors",
                          "Vendor",
                        )}`
                      : `Add ${getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "vendors",
                          "Vendor",
                        )}`
                }
                handleOpen={() => {}}
                handleClose={() => {
                  setEdit(false);
                  setOnlyKyc(false);
                  setVendorId(null);
                  setShowAddEditVendor(false);
                }}
                buttonText={""}
                className={"overflow-hidden"}
                open={showAddEditVendor}
                buttonClassName={""}
                setOpen={setShowAddEditVendor}
                mobileCancelHidden={true}
                write={true}
              >
                <AddEditVendor
                  edit={edit}
                  setEdit={setEdit}
                  onlyKyc={onlyKyc}
                  toggleShowAddEditVendor={toggleShowAddEditVendor}
                  vendorID={vendorId}
                  fetchVendors={() => fetchEnhancedCDDs(limit, page)}
                  org={true}
                  amlCTFEnable={amlCTFEnable}
                />
              </ResponsiveDrawerForm>
            </>
          ) : (
            <></>
          )}

          <Confirmation
            title={`Check All Pending Status`}
            open={showAllStatus}
            setOpen={setShowAllStatus}
            toggleShow={() => {
              toggleShowAllStatus();
            }}
            className="sm:max-w-fit"
            popupType={"cdds"}
            message={
              <>
                <p>Would you like to check all the kyc verification status?</p>
              </>
            }
            okAction={async () => {
              handleAllStatus();
            }}
            loading={loading}
            cancelAction={async () => {
              toggleShowAllStatus();
            }}
          />
        </div>
      </MainBody>
    </>
  ) : (
    <UnauthorisedAccess expandList={true} popup={true} />
  );
};

export default EnhancedCDD;
// * End: Vendor Listing Page
